angular.module('impactx.sapconfig').controller('CurrencyCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    CurrencyCtrl]);

function CurrencyCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService) {
    var self = this;
    
    dataGen.getData($scope, {sapConfigId: $routeParams.sapConfigId}, '/sapconfiguration/currency/view').then(function () {
        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm($scope, {currencyData: $scope.data}, '/sapconfiguration/currency/save').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.addCurrency = function () {
        if (impactX.isDefined($scope, 'data.templateCurrency')) {
            var copy = {};
            angular.copy($scope.data.templateCurrency, copy);
            $scope.data.currencies.push(copy);
        }
    };

    self.removeCurrency = function (currency) {
        var length = $scope.data.currencies.length;
        if (length > 0) {
            var indexOf = $scope.data.currencies.indexOf(currency);
            if (indexOf > -1) {
                $scope.data.currencies.splice(indexOf, 1);
            }
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.addCurrency,
                action: self.addCurrency,
                type: 'dialogaction',
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}